import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { Amplify } from 'aws-amplify';
// Material Design Icons
import '@mdi/font/css/materialdesignicons.css'

const vuetify = createVuetify({
  components,
  directives,
})

const app = createApp(App)

// Initialize store with persisted data
store.dispatch('initializeStore')

// Navigation guard for authentication
router.beforeEach((to, from, next) => {
  const isLoggedIn = store.getters.isLoggedIn || false

  if (to.meta.requiresAuth && !isLoggedIn) {
    next('/login')
  } else if (to.path === '/login' && isLoggedIn) {
    next('/teams')
  } else {
    next()
  }
})


try {
  Amplify.configure({

    Auth: {
      Cognito: {
        userPoolId: "us-east-1_17hCnWgdX",
        userPoolClientId: "407c5t7d946oje1rnubr6amaoc",
        signUpVerificationMethod: "code",
        loginWith: {
          email: true,
        },
      },
    },
    API: {
      GraphQL: {
        endpoint:
          "https://r6jattiayfg2fix7fhpovyncly.appsync-api.us-east-1.amazonaws.com/graphql ",
        region: "us-east-1",
        defaultAuthMode: "userPool",
      },

    },
  });
} catch (error) {
  console.error("Amplify configuration error:", error);
}


app
  .use(store)
  .use(router)
  .use(vuetify)
  .mount('#app')
